import { IconButton, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from "@mui/material";
import type { NavItem } from "@/types/navigation";

interface NavRowProps {
  readonly item: NavItem;
  readonly isCollapsed: boolean;
  readonly isActive: boolean;
  readonly onSelect: (key: string) => void;
}

const NavRow = ({ item, isCollapsed, isActive, onSelect }: NavRowProps) => {
  const Icon = item.icon;
  const isDisabled = item.disabled === true;

  if (isCollapsed) {
    return (
      <Tooltip title={item.label} placement="right">
        <span style={{ display: "inline-flex" }}>
          <IconButton
            {...(isDisabled ? { disabled: true } : { onClick: () => onSelect(item.key) })}
            sx={{
              width: 40,
              height: 40,
              borderRadius: 1,
              ...(isDisabled && { opacity: 0.45 }),
              ...(isActive && { bgcolor: "action.selected" })
            }}
          >
            <Icon />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <ListItemButton
      {...(isDisabled ? { disabled: true } : { onClick: () => onSelect(item.key) })}
      sx={{
        px: 2,
        py: 1,
        ...(isDisabled && { opacity: 0.6 }),
        ...(isActive && { bgcolor: "action.selected" })
      }}
    >
      <ListItemIcon sx={{ minWidth: 56, color: "text.secondary" }}>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={<Typography variant="body2">{item.label}</Typography>} />
      {typeof item.count === "number" ? (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {item.count}
        </Typography>
      ) : null}
    </ListItemButton>
  );
};

export default NavRow;
